export const goalTrackingData = [
  {
    GoalType: "Development Goals",
    Subject: "Programming Skills",
    TargetAchievement: "Complete a HTML course",
    StartDate: "14 Jan 2024",
    EndDate: "13 Mar 2024",
    Description: "Improve proficiency",
    Status: "Active",
    Progress: "Completed 70%",
    key: "1",
  },
  {
    GoalType: "Project Goals",
    Subject: "App Development",
    TargetAchievement: "Deliver the app",
    StartDate: "21 Jan 2024",
    EndDate: "21 Feb 2024",
    Description: "Complete the app",
    Status: "Active",
    Progress: "Completed 40%",
    key: "2",
  },
  {
    GoalType: "Project Goals",
    Subject: "Web Development",
    TargetAchievement: "Deliver the template",
    StartDate: "18 Feb 2024",
    EndDate: "18 Mar 2024",
    Description: "Complete the template",
    Status: "Active",
    Progress: "Completed 60%",
    key: "3",
  },
];
